var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { emptyDocumentOcr } from './documentOcr';
var aliases = new Set(['SERVICE_OCR', 'SERVICE_OCR_REACT']);
export var hasBackendDocumentOcr = function (step) {
    return __spreadArray(__spreadArray([], (step.services || []), true), step.fields.reduce(function (all, field) { return all.concat(field.services || []); }, []), true).some(function (alias) { return aliases.has(alias.toUpperCase()); });
};
export var ocrServiceSignature = function (service) {
    return JSON.stringify([service.serviceAlias, service.createdDate, service.status, service.fields]);
};
export var readBackendDocumentOcr = function (fields) {
    var data = emptyDocumentOcr();
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        var alias = field.field.toLowerCase();
        var key = alias === 'naturality' ? 'birthplace' : alias;
        if (Object.prototype.hasOwnProperty.call(data, key) && typeof field.value === 'string') {
            data[key] = field.value;
        }
    }
    return data;
};
export var findCompletedDocumentOcr = function (result, baseline) {
    var services = (result.services || []).filter(function (service) { return aliases.has(service.serviceAlias.toUpperCase()); });
    // Results are ordered oldest first by the API. Never show a previous extraction.
    var service = services.slice().reverse().find(function (item) { return !baseline.has(ocrServiceSignature(item)); });
    if (!service || !['APPROVED', 'REFUSED', 'ERROR', 'CANCELED'].includes(service.status.toUpperCase()))
        return null;
    return { fields: service.fields || [], data: readBackendDocumentOcr(service.fields || []), approved: service.status.toUpperCase() === 'APPROVED' };
};
export var waitForDocumentOcr = function (token, baseline, signal, fetchResult) { return __awaiter(void 0, void 0, void 0, function () {
    var deadline, result, completed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deadline = Date.now() + 90000;
                _a.label = 1;
            case 1:
                if (!(!signal.aborted && Date.now() < deadline)) return [3 /*break*/, 4];
                return [4 /*yield*/, fetchResult({ tokenOnboarding: token, signal: signal })];
            case 2:
                result = _a.sent();
                if (signal.aborted)
                    throw new Error('OCR canceled');
                if (result.tokenOnboarding !== token)
                    throw new Error('OCR token mismatch');
                completed = findCompletedDocumentOcr(result, baseline);
                if (completed)
                    return [2 /*return*/, completed];
                return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var abort = function () { clearTimeout(timer); reject(new Error('OCR canceled')); };
                        var timer = setTimeout(function () { signal.removeEventListener('abort', abort); resolve(); }, 2000);
                        signal.addEventListener('abort', abort, { once: true });
                        if (signal.aborted)
                            abort();
                    })];
            case 3:
                _a.sent();
                return [3 /*break*/, 1];
            case 4: throw new Error('OCR timed out');
        }
    });
}); };
